import ShortTextIcon from '@material-ui/icons/ShortText';
import LabelIcon from '@material-ui/icons/TextFields';
import DropdownIcon from '@material-ui/icons/ArrowDropDownOutlined';
import CheckboxIcon from '@material-ui/icons/CheckBox';
import FileUploadIcon from '@material-ui/icons/CloudUpload';
import PortraitIcon from '@material-ui/icons/Portrait';
import DateIcon from '@material-ui/icons/DateRange';
import RepeatableIcon from '@material-ui/icons/LibraryAdd';
import AlertIcon from '@material-ui/icons/ErrorOutline';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

export const newChoiceObject = { label: 'New Choice', value: 'New Choice' };

export default function getNewEntry(typeId, section, entry) {
    if (!typeId) {
        return null;
    }
    const entryBase = {
        typeId: typeId,
        field: `Field ${section}-${entry}`,
        width: 12,
    };
    const basicEntryProps = {
        instructions: '',
        label: '',
        additionalInfo: '',
        rules: null,
        visibilityConditions: null,
        fieldMapping: {
            targetPath: '',
        },
        initialValue: null,
    };
    let newEntry = null;
    switch (typeId) {
        case 'textBlock':
            newEntry = {
                ...entryBase,
                text: 'Enter Text or Heading',
                additionalInfo: '',
            };
            break;
        case 'choices':
            newEntry = {
                ...entryBase,
                ...basicEntryProps,
                choices: [newChoiceObject, newChoiceObject, newChoiceObject],
            };
            break;
        case 'boolean':
            newEntry = {
                ...entryBase,
                ...basicEntryProps,
                label: 'New Checkbox',
            };
            break;
        case 'date':
            newEntry = {
                ...entryBase,
                ...basicEntryProps,
            };
            break;
        case 'fileUpload':
            newEntry = {
                ...entryBase,
                instructions: '',
                label: '',
                additionalInfo: '',
                rules: null,
            };
            break;
        case 'photoUpload':
            newEntry = {
                ...entryBase,
                instructions: '',
                label: '',
                additionalInfo: '',
                rules: null,
            };
            break;
        case 'alert':
            newEntry = {
                ...entryBase,
                alertType: 'error',
                title: 'Edit Alert',
                text: '',
                visibilityConditions: null,
            };
            break;
        case 'multiple':
            newEntry = {
                ...entryBase,
                ...basicEntryProps,
                fields: [],
                displayExpression: '',
                secondaryDisplayExpression: '',
            };
            break;
        case 'system':
            newEntry = {
                ...entryBase,
                fieldMapping: {
                    targetPath: '',
                },
            };
            break;
        default:
            newEntry = {
                ...entryBase,
                ...basicEntryProps,
                mask: null,
            };
            break;
    }

    return newEntry;
}

export const Fields = [
    {
        typeId: 'textBlock',
        icon: LabelIcon,
    },
    {
        typeId: 'textInput',
        icon: ShortTextIcon,
    },
    {
        typeId: 'choices',
        icon: DropdownIcon,
    },
    {
        typeId: 'boolean',
        icon: CheckboxIcon,
    },
    {
        typeId: 'fileUpload',
        icon: FileUploadIcon,
    },
    {
        typeId: 'photoUpload',
        icon: PortraitIcon,
    },
    {
        typeId: 'date',
        icon: DateIcon,
    },
    {
        typeId: 'alert',
        icon: AlertIcon,
    },
    {
        typeId: 'multiple',
        icon: RepeatableIcon,
    },
    {
        typeId: 'system',
        icon: VisibilityOffIcon,
    },
];
export function typeToDisplay(typeId) {
    let typeDisplay = null;
    switch (typeId) {
        case 'textBlock':
            typeDisplay = 'Text Block';
            break;
        case 'textInput' || 'shortText':
            typeDisplay = 'Text Box';
            break;
        case 'choices':
            typeDisplay = 'Dropdown';
            break;
        case 'boolean':
            typeDisplay = 'Check Box';
            break;
        case 'fileUpload':
            typeDisplay = 'File Upload';
            break;
        case 'photoUpload':
            typeDisplay = 'Photo ID Upload';
            break;
        case 'date':
            typeDisplay = 'Date';
            break;
        case 'multiple':
            typeDisplay = 'Repeatable Field';
            break;
        case 'alert':
            typeDisplay = 'Alert';
            break;
        case 'system':
            typeDisplay = 'System';
            break;
        default:
            typeDisplay = 'undefined';
            break;
    }
    return typeDisplay;
}
